<!-- MexIndex.vue -->
<template>
    <main role="main">
        <!-- Sección de breadcrumb -->
        <mex-breadcrumb></mex-breadcrumb>
        <section class="has-background-grey p-5">
            <div class="container is-max-desktop">
                <div class="columns is-multiline">
                    <div class="column">
                        <header>
                            <h1 class="has-gob-title">Módulos Express ChileAtiende</h1>
                            <span class="is-lower-text-title">Accede a servicios de forma rápida y sencilla.</span>
                        </header>
                    </div>
                </div>
            </div>
        </section>

        <section class="p-5">
            <div class="container is-max-desktop">
                <div class="columns">
                    <div class="column is-8">
                        <p>Estos dispositivos de autoatención te permiten <strong>obtener tu ClaveÚnica, imprimir certificados y más.</strong> Revisa los servicios disponibles y sus ubicaciones.</p>
                    </div>
                </div>
                <b-tabs type="is-boxed" class="is-danger" ref="buefyTabs">
                    <b-tab-item label="Servicios disponibles">
                        <mex-servicios></mex-servicios>
                    </b-tab-item>
                    <b-tab-item label="Ubicación módulos">
                        <mex-ubicaciones :data="data" class="mb-6"></mex-ubicaciones>
                    </b-tab-item>
                </b-tabs>
            </div>
        </section>

    </main>
</template>
<script>
import MexServicios from './components/MexServicios.vue'
import MexUbicaciones from './components/MexUbicaciones.vue'
import MexBreadcrumb from './components/MexBreadcrumb.vue';

export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.$nextTick(() => {
            // Asegurar que las pestañas sean tabulables
            this.interval = setInterval(() => {
                if (this.$refs.buefyTabs && this.$refs.buefyTabs.$el) {
                    const tabsElement = this.$refs.buefyTabs.$el;
                    // Agregar la clase text-acc y my-0 al elemento nav
                    const navElement = tabsElement.querySelector('nav.tabs');
                    if (navElement) {
                        if (!navElement.classList.contains('text-acc')) {
                            navElement.classList.add('text-acc');
                        }
                        if (!navElement.classList.contains('my-0')) {
                            navElement.classList.add('my-0');
                        }
                    }
                    const tabLinks = tabsElement.querySelectorAll('nav.tabs ul li a');

                    // Mantener tabindex="0" en todas las pestañas
                    tabLinks.forEach(link => {
                        if (link.getAttribute('tabindex') !== '0') {
                            link.setAttribute('tabindex', '0');
                        }
                    });
                }
            }, 100);

            // Añadir listener para manejar la tecla Tab
            document.addEventListener('keydown', this.handleTabKey);
        });
    },
    beforeDestroy() {
        // Limpiar el intervalo y listeners cuando el componente se destruye
        clearInterval(this.interval);
        document.removeEventListener('keydown', this.handleTabKey);
    },
    methods: {
        handleTabKey(e) {
            // Sólo nos interesa la tecla Tab cuando se presiona Shift (retroceso)
            if (e.key === 'Tab' && e.shiftKey && this.$refs.buefyTabs && this.$refs.buefyTabs.$el) {
                const tabsElement = this.$refs.buefyTabs.$el;
                const tabItems = tabsElement.querySelectorAll('nav.tabs ul li[role="tab"]');
                const tabLinks = tabsElement.querySelectorAll('nav.tabs ul li a');

                // Verificar si estamos regresando a la primera pestaña
                const activeElement = document.activeElement;
                const activeTabLink = Array.from(tabLinks).find(link => link === activeElement);

                if (activeTabLink) {
                    const activeTabItem = activeTabLink.closest('li[role="tab"]');
                    const tabIndex = Array.from(tabItems).indexOf(activeTabItem);

                    // Si estamos en la segunda pestaña y vamos a regresar a la primera
                    if (tabIndex === 1) {
                        const firstTab = tabItems[0];
                        const secondTab = tabItems[1];

                        // Añadir un evento que se ejecutará después de cambiar el foco
                        // para asegurar que la primera pestaña se active visualmente
                        setTimeout(() => {
                            // Si ya regresamos a la primera pestaña (tiene el foco)
                            if (document.activeElement === tabLinks[0]) {
                                // Activar la primera pestaña programáticamente
                                this.activateTab(firstTab, tabItems);

                                // Ejecutar el clic programáticamente para asegurar
                                // que Buefy actualice el estado interno
                                tabLinks[0].click();
                            }
                        }, 10);
                    }
                }
            }
        },

        activateTab(tabToActivate, allTabs) {
            // Desactivar todas las pestañas
            allTabs.forEach(tab => {
                tab.setAttribute('aria-selected', 'false');
                tab.classList.remove('is-active');
            });

            // Activar la pestaña seleccionada
            tabToActivate.setAttribute('aria-selected', 'true');
            tabToActivate.classList.add('is-active');
        }
    },
    components: {
        MexServicios,
        MexUbicaciones,
        MexBreadcrumb
    }
}
</script>